import { render, staticRenderFns } from "./addressEditModel.vue?vue&type=template&id=b9804a16&scoped=true&"
import script from "./addressEditModel.vue?vue&type=script&lang=js&"
export * from "./addressEditModel.vue?vue&type=script&lang=js&"
import style0 from "./addressEditModel.vue?vue&type=style&index=0&id=b9804a16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9804a16",
  null
  
)

export default component.exports